// apiService.js

import { Membership } from '../api/center';
import {
    getAuthentificationPhoneNumber,
    getClassFeeSettlement,
    getClassFeeSettlementExcel,
    getClassFeeSettlementForMembership,
    GetClassFeeSettlementParamsType,
    getOneMember,
} from '../api/member';
import { MemberShipApiType } from '../api/memberShip';
import { OnboardingGoal } from '../lib/varialbe';
import { MemberMembershipDataType, MemberScheduleDataType } from './useMembershipQueryService';

export const fetchOneMemberProfile = (
    params: {
        centerId: string;
        memberId: string;
    },
    authorization: string
) => ({
    queryKey: ['getCenterMemberList', params.centerId, params.memberId],
    queryFn: () => getOneMember(params.centerId, params.memberId, authorization),
    onSuccess: (data: any) => {
        // 데이터 정제 로직
        return data?.data?.member ?? undefined;
    },
});

export const fetchAuthentificationPhoneNumber = (
    params: { centerId: string; phoneNumber: string },
    authorization: string
) => ({
    queryKey: ['getAuthentificationPhoneNumber', params.phoneNumber],
    queryFn: () =>
        getAuthentificationPhoneNumber({
            centerId: params.centerId,
            phoneNumber: params.phoneNumber,
            accessToken: authorization,
        }),
    onSuccess: (data: any) => {
        const result: FetchAuthentificationPhoneNumberResponse = data?.data?.result ?? {};
        // 데이터 정제 로직
        return result;
    },
});
// getClassFeeSettlement
export const fetchGetClassFeeSettlement = (params: GetClassFeeSettlementParamsType, authorization: string) => ({
    queryKey: ['getClassFeeSettlement', params.centerId, params.startDate, params.endDate, params.selectedCoach],
    queryFn: () =>
        getClassFeeSettlement({
            centerId: params.centerId,
            startDate: params.startDate,
            endDate: params.endDate,
            selectedCoach: params.selectedCoach,
            accessToken: authorization,
        }),
    onSuccess: (data: any) => {
        // // 데이터 정제 로직
        const result: FetchGetClassFeeSettlementResponse = data.data ?? {};

        return result;
    },
});
// fetchGetClassFeeSettlementExcel
export const fetchGetClassFeeSettlementExcel = (params: GetClassFeeSettlementParamsType, authorization: string) => ({
    queryKey: ['getClassFeeSettlementExcel', params.centerId, params.startDate, params.endDate, params.selectedCoach],
    queryFn: () =>
        getClassFeeSettlementExcel({
            centerId: params.centerId,
            startDate: params.startDate,
            endDate: params.endDate,
            selectedCoach: params.selectedCoach,
            accessToken: authorization,
        }),
    onSuccess: (data: any) => {
        // // 데이터 정제 로직
        const result: FetchGetClassFeeSettlementResponse = data.data ?? {};

        return result;
    },
});
// getClassFeeSettlement
export const fetchGetClassFeeSettlementForMembership = (
    params: GetClassFeeSettlementParamsType,
    authorization: string
) => ({
    queryKey: [
        'getClassFeeSettlementForMembershipQuery',
        params.centerId,
        params.startDate,
        params.endDate,
        params.selectedCoach,
    ],
    queryFn: () =>
        getClassFeeSettlementForMembership({
            centerId: params.centerId,
            startDate: params.startDate,
            endDate: params.endDate,
            selectedCoach: params.selectedCoach,
            accessToken: authorization,
        }),
    onSuccess: (data: any) => {
        // // 데이터 정제 로직
        const result: FetchGetClassFeeSettlementResponse = data.data ?? {};

        return result;
    },
});

export type FetchAuthentificationPhoneNumberResponse = {
    coachName: string;
    centerName: string;
    weight: WeightRecord;
    height: number;
    birthday: string;
    gender: 'male' | 'female';
};

type WeightRecord = {
    value: number;
    recordDate: string; // ISO 날짜 문자열로 정의
};

export type MemberProfile = {
    inviteCode: string;
    isInfo: boolean;
    /** 앱 가입(auth) 여부 — isInfo(온보딩 완료)보다 정확. 표시·필터는 이 값을 사용. */
    appLinked?: boolean;
    appAccountStatus?: 'linked' | 'withdrawn' | 'unlinked';
    appWithdrawnAt?: string;
    appWithdrawalAuthStatus?: 'pending' | 'revoked' | null;
    isRequest: boolean;
    isDeleted: boolean;
    isCanceled: boolean; // 추가된 필드
    memberType: 'temp' | 'regular' | 'premium'; // 추가된 필드, 예시로 Enum 형태로 정의 가능
    name: string;
    phoneNumber: string;
    gender: 'male' | 'female';
    height: number;
    weight: WeightRecord[];
    address: string; // 추가된 필드
    memo: string;
    centerId: string; // 추가된 필드
    created: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    birthday: string;
    exerciseVolume: string;
    profileImageUrl: string;
    profileColorType: string;
    profileName: string;
    coachProfileImageUrl: string;
    coachProfileColorType: string;
    coachProfileName: string;
    coachId: string;
    coachName: string;
    id: string;
    goal: {
        type: OnboardingGoal;
        context?: string;
    };
};

// 전체 데이터 타입
export interface FetchGetClassFeeSettlementResponse {
    coachs: Coach[];
    summaryData: GetClassFeeSettlementSummaryData;
    // tableDataByMember: GetClassFeeSettlementTableData[];
    tableDataBySchedule: MemberMembershipDataType[];
    tableDataByMembership: GetClassFeeSettlementTableDataForMembership[];
    filters: Filters;
}

interface Coach {
    coachId: string;
    coachName: string;
}
export interface GetClassFeeSettlementSummaryData {
    totalScheduleFee: number; // 총 수업료
    totalPricePerSchedule: number; // 총 등록 단가
    totalRemainSession: number; // 총 남은 수업 수
    totalAttendanceScheduleCount: number; // 총 완료 수업 수
    totalNoshowScheduleCount: number; // 총 노쇼 수
    totalScheduleMemberCount: number; // 수업한 회원 수
}
// 테이블 데이터 타입
export interface GetClassFeeSettlementTableData {
    memberId: string;
    memberName: string;
    coachId: string;
    coachName: string;
    attendanceScheduleCount: number;
    noshowScheduleCount: number;
    remainSession: number;
    memberTotalScheduleFee: number;
    commission: number;
    commissionType: 'fixed' | 'percentage';
    membershipInfo: MembershipInfo;
    scheduleRecord: ClassFeeSettlementScheduleRecord;
}

export interface GetClassFeeSettlementTableDataForMembership {
    memberId: string;
    memberName: string;
    coachId: string;
    coachName: string;
    attendanceScheduleCount: number; // 완료
    noshowScheduleCount: number; // 노쇼
    remainSession: number; // 남은 수업수
    /**
     * 서버가 내려주는 현재 수강권 상태. remainSession 은 조회 월 말 기준 잔여라 만료 수강권도 0 이 아닐 수 있어
     * 화면은 이 값으로 '만료' 배지를 붙인다. 구버전 서버는 필드가 없으므로 optional.
     */
    membershipStatus?: string;
    isCanceled?: boolean;
    memberTotalScheduleFee: number; // 수업 정산액
    commission: number | null;
    commissionType: 'percentage' | 'fixed';
    // sessionTier 전용: 이번 달 수업들에 2개 이상 서로 다른 commissionRate가 적용된 경우 true
    isCompositeRate?: boolean;
    effectiveCommissionRate?: number | null;
    cumulativeSessionCount?: number | null;
    pricePerSchedule: number; // 회당 가격
    activationDate: string;
    expirationDate: string;
    membershipName: string; // 수강권 이름
    membershipId: string;
    createdAt: string; // 발급 일자
    membershipInfo: MembershipInfo; // 수강권 정보
    scheduleRecord: ScheduleRecord;
    isCustomedCommission: boolean;
    /**
     * 수강권 종류 구분 — 그룹수업 통합(ReservationRules.includeGroupClassInSettlement) ON 시
     * 서버가 그룹 수강권 row를 'group'으로 표시해서 동일 shape으로 섞어서 반환한다.
     * - 'pt': 기존 Membership row (기본값, 미설정 가능)
     * - 'group': MemberTicket row — membershipId는 MemberTicket _id, pricePerSchedule은
     *   ticket.perSessionFee. scheduleRecord.allSchedules는 빈 배열.
     */
    source?: 'pt' | 'group';
}

export type ScheduleRecord = {
    allSchedules: MemberScheduleDataType[];
    coachName: string;
    memberName: string;
    membershipName: string;
    membershipBGColor: string[];
};

export interface ClassFeeSettlementScheduleRecord {
    allSchedules: MemberScheduleDataType[];
    coachName: string;
    memberName: string;
    membershipBGColor?: string[];
    membershipName: string;
}

// 회원 정보 타입
interface MemberInfo {
    memberName: string;
    profileImageUrl: string;
    age: number;
    isNewSales: boolean;
    gender: string;
}

// 멤버십 세부 정보 타입
export interface MembershipInfo {
    coachName: string;
    memberInfo: MemberInfo;
    membership: Membership;
}
// 필터 데이터 타입
interface Filters {
    memberList: {
        memberId: string;
        memberName: string;
    }[];
    membershiptemplateList: {
        membershipTemplateId: string;
        membershipTemplateName: string;
    }[];
}
